import React from 'react'
import { Link } from 'react-router-dom';
import htmlIcon from '../Images/html-5-logo-svgrepo-com.svg'
import tailwind from '../Images/tailwind-svgrepo-com.svg'
import reactIcon from '../Images/react-svgrepo-com.svg'

import linkedInIcon from '../Images/linkedin-icon-2-logo-svgrepo-com.svg'
import githubIcon from '../Images/github-142-svgrepo-com.svg'
import gmailIcon from '../Images/gmail-svgrepo-com.svg'

const Footer = () => {
  return (
    <div className=" relative bottom-0 w-full md:h-[300px] h-[200px] bg-violet-900  overflow-hidden overflow-x-hidden">

      <div className="hidden  container md:flex md:justify-around justify-between mx-auto w-full md:pt-10 pt-5 gap-4">
        <Link href="#top" className='text-white md:text-3xl text-xl hover:text-gray-300 text-center' to="/">Home</Link>
        <Link className='text-white md:text-3xl text-xl hover:text-gray-300 text-center' to="/Jewellery">Jewellery</Link>
        <Link className='text-white md:text-3xl text-xl hover:text-gray-300 text-center' to="/Mens">Men's Collection</Link>
        <Link className='text-white md:text-3xl text-xl hover:text-gray-300 text-center' to="/Womens">Women's Collection</Link>
      </div>

      <div className='w-full md:mt-5 mt-2  pb-2 '>


        <div className='w-full grid grid-cols-1 md:grid-cols-2 mt-3 md:mt-7 select-none' >

          <div className='w-full flex flex-col gap-3 items-center'>
            <span className='mt-2 text-white text-md md:text-3xl w-full text-center'>Tech Stack used</span>
            <div className='flex justify-center gap-5 md:gap-8'>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><img src={htmlIcon} title='HTML' /></span>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><img src={tailwind} title='Tailwind CSS' /></span>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><img src={reactIcon} title='React JS' /></span>
            </div>
          </div>



          <div className='w-full flex flex-col gap-3 items-center '>
            <span className='mt-2 text-white text-md md:text-3xl w-full text-center'>Developer Contact</span>
            <div className='flex justify-center gap-5 md:gap-8'>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><a target='_blank'  href='https://www.linkedin.com/in/jimish-khokhar-188121255/'><img src={linkedInIcon} title='LinkedIn Profile'/></a></span>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><a target='_blank' href='https://github.com/JimishKhokhar'><img src={githubIcon} title='GitHub Profile' /></a></span>
              <span className='w-[30px] md:w-[50px] flex justify-center items-center'><a target='_blank' href = "mailto: jimishkhokhar811@gmail.com"><img src={gmailIcon} title='Gmail Account' /></a></span>
            </div>
          </div>




        </div>


      </div>


      <div className="  absolute bottom-0 bg-violet-950 pt-1 w-full h-[1.5em] text-lg text-center text-white flex flex-col justify-center">
        <h2 className='select-none'>CopyRight © 2023 OnlineAdda.com</h2>
      </div>
    </div>
  )
}

export default Footer;